import React, { createContext, useContext } from 'react';

import { useObjectState, UseObjectStateReturnType } from '@utils/hooks';

type TCountDownNotification = {
  id?: string;
  text: string;
  onTimeExpired?<T>(args?: T): void;
  onCancel?<T>(args?: T): void;
};

type TCountDownNotificationContext = UseObjectStateReturnType<TCountDownNotification>;

const CountDownNotificationContext = createContext<TCountDownNotificationContext>(
  {} as TCountDownNotificationContext
);

const CountDownNotificationContextProvider: CustomFC = ({ children }) => {
  const [state, setState] = useObjectState({
    text: '',
  });

  return (
    <CountDownNotificationContext.Provider value={[state, setState]}>
      {children}
    </CountDownNotificationContext.Provider>
  );
};

export const useCountDownNotificationContext = (): TCountDownNotificationContext =>
  useContext(CountDownNotificationContext);

export default CountDownNotificationContextProvider;
